import type { IconData } from '@stacksjs/iconify-core'

export const interfaceEssentialShare3: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M25.91 13.71h1.52v15.24h-1.52Zm-1.53 15.24h1.53v1.53h-1.53Zm0-16.76h1.53v1.52h-1.53Zm-3.04-1.52h3.04v1.52h-3.04ZM7.62 30.48h16.76V32H7.62ZM15.24 0v1.52h-1.52v1.53h-1.53v1.52h-1.52v1.52H9.15v1.53h4.57v9.14h4.57V7.62h4.57V6.09h-1.52V4.57h-1.53V3.05h-1.52V1.52h-1.53V0zM7.62 10.67h3.05v1.52H7.62ZM6.1 28.95h1.52v1.53H6.1Zm0-16.76h1.52v1.52H6.1Zm-1.53 1.52H6.1v15.24H4.57Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default interfaceEssentialShare3
